import React, { useState } from 'react';
// import * as XLSX from 'xlsx-js-style';
import { 
  Upload, 
  Button, 
  Table, 
  Input, 
  Space, 
  Card, 
  message, 
  Row, 
  Col,
  DatePicker,
  // Popconfirm,
  Tabs
} from 'antd';
import { 
  UploadOutlined, 
  // DeleteOutlined, 
  // PlusOutlined, 
  DownloadOutlined 
} from '@ant-design/icons';
import { readTotalSalary, readOther } from './excelRead';
import allocationProject from './allocation';
import { showGlobalLoading, hideGlobalLoading } from './globalLoading';
import exportProjectExcel from './exportExcel';
import './AntdExcelEditor.css';

// const { Dragger } = Upload;

const AntdExcelEditor = () => {
  const [files, setFiles] = useState([{
    name: '总薪资表',
    fileList: [],
    headerList: [],
    dataList: [],
  }, {
    name: '科研薪资表',
    fileList: [],
    headerList: [],
    dataList: [],
  }, {
    name: '项目表',
    fileList: [],
    headerList: [],
    dataList: [],
  }]);
  const [date, setDate] = useState('');
  // const [data, setData] = useState([]);
  // const [headers, setHeaders] = useState([]);
  // const [activeFileIndex, setActiveFileIndex] = useState(null);
  const [tabs, setTabs] = useState(() => {
    return ['部门统计表', '分配项目工时', '分配项目人工成本', '项目表'].map((eve, i) => {
      const id = String(i + 1);
      return {
        label: eve,
        key: id,
        children: <Table 
          columns={[]}
          dataSource={[]}
          bordered
          scroll={{ x: true, y: true }}
        />,
      };
    })
  });

  const [allocationData, setAllocationData] = useState({
    department: [],
    projectTime: [],
    projectManualCost: [],
    projectList: [],
  });

  const [exportFileName, setExportFileName] = useState('');


  // 上传前校验文件类型
  const beforeUpload = (file, index) => {
    const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                   file.type === 'application/vnd.ms-excel';
    if (!isExcel) {
      message.error('只能上传Excel文件 (.xlsx 或 .xls)');
    }
    return isExcel;
  };

  // 处理文件变化
  const handleFileChange = (info, index) => {
    if (info.file.status === 'done') {
      const newFiles = [...files];
      newFiles[index].fileList = info.fileList;//info.file.originFileObj;
      setFiles(newFiles);
      readExcel(info.file.originFileObj, index);
      message.success(`${info.file.name} 文件上传成功`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} 文件上传失败`);
    } else if (info.file.status === 'removed') {
      const newFiles = [...files];
      newFiles[index].fileList = info.fileList;
      newFiles[index].headerList = [];
      newFiles[index].dataList = [];
      setFiles(newFiles);
    }
  };

  // // 添加文件上传框
  // const addFileUpload = () => {
  //   if (files.length < 2) {
  //     setFiles([...files, null]);
  //   } else {
  //     message.warning('最多只能上传2个文件');
  //   }
  // };

  // // 删除文件上传框
  // const removeFileUpload = (index) => {
  //   const newFiles = [...files];
  //   newFiles.splice(index, 1);
  //   setFiles(newFiles);
    
  //   if (activeFileIndex === index) {
  //     setActiveFileIndex(null);
  //     setData([]);
  //     setHeaders([]);
  //   } else if (activeFileIndex > index) {
  //     setActiveFileIndex(activeFileIndex - 1);
  //   }
  // };

  // 读取Excel文件
  const readExcel = (file, index) => {
    try{
      showGlobalLoading('上传中，请稍侯...');
      const readFunc = index === 0 ? readTotalSalary : readOther;
      readFunc(file, (headers, rows) => {
        const newFiles = [...files];
        newFiles[index].headerList = headers;
        newFiles[index].dataList = rows;
        setFiles(newFiles);
        hideGlobalLoading();
      });
    }catch(e) {
      message.error('文件读取失败，请检查文件格式是否正确');
      hideGlobalLoading();
    }
  };

  const handleDateChange = (dates) => {
    setDate(dates.format('YYYYMM'));
  };

  const getTableColumns = (headers) => {
    return headers.map((header, dataIndex) => {
      const column = {
        title: header,
        dataIndex: dataIndex,
        key: dataIndex,
        width: 80,
        minWidth: 80,
        align: 'center',
        ellipse: true,
      }
      return column;
      // if (tableName === 'project') {
      //   return column;
      // }
      // column.render = (text, record, index) => {
      //   const { editing, data } = useCellEditing(tableName, record, dataIndex, index);
      //   return editing ? (
      //     <Input
      //       value={data[dataIndex]}
      //       onChange={(e) => handleChange(tableName, index, dataIndex, e.target.value)}
      //       onBlur={() => toggleEditing(tableName, index, null)}
      //       autoFocus
      //     />
      //   ) : (
      //     <span onClick={() => toggleEditing(tableName, index, dataIndex)}>{text}</span>
      //   );
      // };
    });
  }

  const allocation = async () => {
    for (let i = 0; i < files.length; i++) {
      if(files[i].headerList.length === 0 || files[i].dataList.length === 0) {
        message.error(`请上传正确的${files[i].name}文件`);
        return;
      }
    }
    if (!date) {
      message.error('请选择分配年月');
      return;
    }
    showGlobalLoading('分配中，请稍侯...');
    try {
      const result = await allocationProject(date, files[0].dataList, files[1].dataList, files[2].dataList);
      // 渲染表格
      const dataMapping = ['department', 'projectTime', 'projectManualCost', 'project'];
      const newTabs = [...tabs];
      newTabs.forEach((item, index) => {
        const currentData = result[dataMapping[index]];
        const columns = getTableColumns(currentData[0]);
        // 只显示人，不显示底部备注信息
        const dataSource = currentData.slice(1, result.retainCount[dataMapping[index]]);
        item.children = <Table 
          columns={columns}
          dataSource={dataSource}
          bordered
          scroll={{ x: true, y: 300 }}
          pagination={false}
          tableLayout="auto"
        />;
      })
      setTabs(newTabs);
      setAllocationData(result);
    } catch (error) {
      console.log('error', error);
      message.error(typeof error === 'string' ? error : '分配失败，请检查数据格式');
    } finally {
      hideGlobalLoading();
    }
  }

  // 处理单元格修改
  // const handleCellChange = (key, header, value) => {
    // setData(prevData => 
    //   prevData.map(row => 
    //     row.key === key ? { ...row, [header]: value } : row
    //   )
    // );
  // };

  // 添加新行
  // const addNewRow = () => {
  //   if (headers.length === 0) return;
    
  //   const newRow = {};
  //   headers.forEach(header => {
  //     newRow[header] = '';
  //   });
  //   newRow.key = `${activeFileIndex}-${Date.now()}`;
    
  //   setData([...data, newRow]);
  // };

  // 删除行
  // const deleteRow = (key) => {
  //   setData(data.filter(row => row.key !== key));
  // };

  // 导出Excel
  const exportExcel = () => {
    if (!exportFileName.trim()) {
      message.warning('请输入导出文件名');
      return;
    }
    if (allocationData.department.length === 0) {
      message.warning('请先分配数据');
      return;
    }

    exportProjectExcel(allocationData, exportFileName);
    message.success('导出成功');
  };

  // 表格列配置
  // const columns = headers.map(header => ({
  //   title: header,
  //   dataIndex: header,
  //   key: header,
  //   render: (text, record) => (
  //     <Input 
  //       value={text} 
  //       onChange={(e) => handleCellChange(record.key, header, e.target.value)}
  //     />
  //   ),
  // }));

  // 添加操作列
  // if (columns.length > 0) {
  //   columns.unshift({
  //     title: '操作',
  //     key: 'action',
  //     render: (_, record) => (
  //       <Popconfirm
  //         title="确定要删除这行吗?"
  //         onConfirm={() => deleteRow(record.key)}
  //         okText="确定"
  //         cancelText="取消"
  //       >
  //         <Button type="link" danger icon={<DeleteOutlined />} />
  //       </Popconfirm>
  //     ),
  //   });
  // }

  return (
    <div className="antd-excel-editor">
      {/* <h1 style={{ textAlign: 'center', marginBottom: 24 }}>Excel 文件编辑器</h1> */}
      <Card title="人员项目工时分配工具" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 16]} align={'middle'}>
          {
            files.map((file, index) => {
              return <>
                <Col span={2} key={index}>
                  {file.name}:
                </Col>
                <Col span={3} key={file.name}>
                  {/* <Dragger
                    name="file"
                    accept=".xlsx,.xls"
                    beforeUpload={(file) => beforeUpload(file, index)}
                    onChange={(info) => handleFileChange(info, index)}
                    multiple={false}
                    maxCount={1}
                    customRequest={({ file, onSuccess }) => {
                      onSuccess('ok')
                    }}
                    className='person-project-upload'
                  >
                    <p className="ant-upload-drag-icon">
                      <UploadOutlined />
                    </p>
                    <p className="ant-upload-text">
                      点击或拖拽文件到此处上传
                    </p>
                    <p className="ant-upload-hint">
                      仅支持Excel文件 (.xlsx, .xls)
                    </p>
                  </Dragger> */}
                  <Upload name="file"
                    accept=".xlsx,.xls"
                    beforeUpload={(file) => beforeUpload(file, index)}
                    onChange={(info) => handleFileChange(info, index)}
                    multiple={false}
                    maxCount={1}
                    customRequest={({ file, onSuccess }) => {
                      onSuccess('ok')
                    }}
                    className='person-project-upload'>
                    <Button icon={<UploadOutlined />}>点击上传</Button>
                  </Upload>
                </Col>
               </>
            })
          }
          <Col span={2}>
            分配年月:
          </Col>
          <Col span={4}>
            <DatePicker onChange={handleDateChange} picker="month" format='YYYY年MM月' allowClear={false} />
          </Col>
          <Col span={3}>
              <Button 
                  type='primary'
                  style={{ width: '100px', height: '40px', fontSize: '16px' }}
                  onClick={allocation}
                >
                  分配
                </Button>
            </Col>
        </Row>
      </Card>

      {/* {data.length > 0 && ( */}
        <Card 
          title={`分配后数据`}
          extra={
            <Space>
              <Input 
                placeholder="输入导出文件名" 
                value={exportFileName}
                onChange={(e) => setExportFileName(e.target.value)}
                style={{ width: 200 }}
              />
              <Button 
                type="primary" 
                icon={<DownloadOutlined />}
                onClick={exportExcel}
              >
                导出Excel
              </Button>
            </Space>
          }
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            {/* <Button 
              type="primary" 
              icon={<PlusOutlined />}
              onClick={addNewRow}
            >
              添加行
            </Button> */}
            {/* <Tabs defaultActiveKey="1" items={items} onChange={onChange} /> */}
            {/* <Table 
              columns={columns}
              dataSource={data}
              bordered
              scroll={{ x: true }}
              pagination={{ pageSize: 10 }}
            /> */}
            <Tabs defaultActiveKey="1" items={tabs} type="card"></Tabs>
          </Space>
        </Card>
      {/* )} */}
    </div>
  );
};

export default AntdExcelEditor;

// 按照基础表进行识别   确认要识别的列名  完成
// 在建项目营收按多少算  给个确定的数值 通过excel导入
// 大中小项目按比例  最终算出来和工资一样 动态调整比例  
// 输出表和发的一样